import { useEffect } from 'react';
import './css/AnimatedBackground.css';

const AnimatedBackground = () => {
  useEffect(() => {
    const interactiveBubble = document.querySelector('.interactive-bubble');
    let curX = 0;
    let curY = 0;
    let tgX = 0;
    let tgY = 0;

    // Function to smoothly move the interactive bubble
    function move() {
      curX += (tgX - curX) / 20;
      curY += (tgY - curY) / 20;
      if (interactiveBubble) {
        interactiveBubble.style.transform = `translate(${Math.round(curX)}px, ${Math.round(curY)}px)`;
      }
      requestAnimationFrame(() => {
        move();
      });
    }

    // Track mouse movement
    const handleMouseMove = (event) => {
      tgX = event.clientX;
      tgY = event.clientY;
    };

    window.addEventListener('mousemove', handleMouseMove);
    move();

    // Clean up event listener
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <>
      {/* Solid color background to prevent shadow issues */}
      <div className="background-solid"></div>
      <div className="animated-background">
        <svg xmlns="http://www.w3.org/2000/svg">
          <defs>
            <filter id="goo">
              <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
              <feColorMatrix 
                in="blur" 
                mode="matrix" 
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" 
                result="goo" 
              />
              <feBlend in="SourceGraphic" in2="goo" />
            </filter>
          </defs>
        </svg>
        <div className="gradients-container">
          <div className="gradient g1"></div>
          <div className="gradient g2"></div>
          <div className="gradient g3"></div>
          <div className="gradient g4"></div>
          <div className="gradient g5"></div>
          <div className="interactive-bubble"></div>
        </div>
      </div>
    </>
  );
};

export default AnimatedBackground; 